// extracted by mini-css-extract-plugin
export default {"content":"Premium_content__D2vPE","wrap":"Premium_wrap__9tS7M","ref":"Premium_ref__1KD7D"};